import { apiCaller } from '../ApiCaller/ApiCaller';

export async function addProdToOpp(addingData) {
    const addProdToOpp  = apiCaller("https://salesforceb2b.customers.bigfivecrm.com/addProductToTheOpportunity", addingData);
      return addProdToOpp;
}